export enum EnumDominioTarea {
  Factura = 1,
  Sujetos,
  Contratos,
  Precios,
  Operaciones,
  Documento,
  Tramitacion,
  LoteLiquidacion,
  Lead,
  Liquidacion,
  EjecucionCF,
  PortalClientesContrato,
  PortalClientesFactura
}
